import api from "@/config/apiConfig"

class ProfileController {
  async index(params = {}) {
    try {
      const response = await api.get("/profile", { params });
      return response.data;
    } catch (error) {
      console.error("Erro no ProfileController.index: ", error);
      throw error;
    }
  }

  async store(data) {
    try {
      const response = await api.post("/profile", data);
      return response.data;
    } catch (error) {
      console.error("Erro no ProfileController.store: ", error);
      throw error;
    }
  }

  async update(id, data) {
    try {
      const response = await api.patch(`/profile/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Erro no ProfileController.update: ", error);
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await api.delete(`/profile/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no ProfileController.delete: ", error);
      throw error;
    }
  }
}

export default new ProfileController();
